// Package imports:
import React, { useEffect, useState } from 'react';
// Component imports:
import DisplayBox from '../../../components/DisplayBox/DisplayBox';
import Loading from '../../../ui-elements/Loading/Loading';
import AssetsReportBody from '../../Property/AssetsSearch/AssetsReportBody';
import Alert from '../../../ui-elements/Alert/Alert';
// Service imports:
import { GET_KELDAN_API_URL } from '../../../services/config';
import { ErrorMessages } from '../../../services/errorMessages';
// Type imports:
import { ICompanyReportModel } from '../../../types/CompanyTypes';
import { Fetched } from '../../../types/Types';
import { IKeldanApiResponse } from '../../../types/KeldanTypes';
import { IPropertyReport } from '../../../types/PropertyTypes';

const ViewPropertiesReport: React.FC<ICompanyReportModel>= ({
    id,
    eventId
}) => {
    const [ propertyReport, setPropertyReport] = useState<Fetched<IPropertyReport>>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const url = `${GET_KELDAN_API_URL()}/Company/GetPropertiesReport/${id}?eventId=${eventId}`;
                const response = await fetch(url);
                if (response.ok) {
                    const responseBody: IKeldanApiResponse<IPropertyReport> = await response.json();
                    if (responseBody.result) {
                        setPropertyReport(responseBody.result);
                    } else if (responseBody.message) {
                        setPropertyReport(new Error(responseBody.message));
                    } else {
                        setPropertyReport(new Error(ErrorMessages.OtherShort));
                    }
                } else {
                    setPropertyReport(new Error(ErrorMessages.RequestFailed));
                }
            } catch (e) {
                setPropertyReport(new Error(ErrorMessages.NetworkError));
            }
        }
        fetchData();
    }, []);

    return propertyReport === null
        ? <DisplayBox
            title='Fasteignir í eigu'
            className='KCL_ViewCompanyAssetsReport'
        >
            <Loading />
        </DisplayBox>
        : propertyReport instanceof Error
        ? <DisplayBox
            title='Fasteignir í eigu'
            className='KCL_ViewCompanyAssetsReport'
        >
            <Alert type='alert' headText={propertyReport.message} />
        </DisplayBox>
        : <AssetsReportBody id={id} eventId={eventId} propertyReport={propertyReport} />
}

export default ViewPropertiesReport;